module.exports = __webpack_public_path__ + "img/b-pink-m@3x.7e6e81fd.png";